import {
  loadAnimation,
  play
} from 'lottie-web'

export default (el, name, animationData) => {
  document.addEventListener('DOMContentLoaded', function(){
    loadAnimation({
      name: name,
      container: el,
      animationData,
      renderer: 'svg',
      loop: false,
      autoplay: false,
    })

    // =======================================
    // set animation trigger for lottie
    // =======================================
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return
          observer.unobserve(entry.target)
          play(name)
        })
      },
      {
        rootMargin: '-25% 0px -25% 0px',
      }
    )

    observer.observe(el)
  })
}
